import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { SendMailService } from './../services/sendmail.service';
import { FormGroup, FormControl, Validators} from '@angular/forms';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
	
	inputName: string = "";
	inputEmail: string = "";
	inputComment: string = "";

	constructor(private router: Router, private _sendMail: SendMailService) { }

  ngOnInit() {
    
  }

  sendContactEmail(){

  	let contactMessage = 
  		{ 
  			FormContactName: this.inputName, 
  			FormContactEmail: this.inputEmail,
  			FormComments: this.inputComment
  		}

  	//this._sendMail.sendTestMessage()
  		//.subscribe(resp => { 
  			//console.log(resp)
  		//});	
  	this._sendMail.sendMessage(contactMessage)
  		.subscribe(resp => { 
  			console.log(resp)
  		});	
  }

}



// WEBPACK FOOTER //
// ./src/app/contact/contact.component.ts